export class CriterioCustom {
  uid: string;
  label: string;
  labelGruppo: string;
  value: string;
  valueLabel: string;
  widthPercentage: number;
  order: number;
  selected: boolean;
  lovUrl: string;
  lovData: string;
  defaultValue: string;
  dataType: string;
  constructor() {
    if (this.dataType === 'combo') {
      this.value = '0';
    }
  }
}

